'use strict';

var Sugar = require('sugar-core'),
    inflectPlurals = require('../inflections/var/inflectPlurals');

Sugar.String.defineInstance({

  'singularize': function(str) {
    return inflectPlurals('singular', String(str));
  }

});

module.exports = Sugar.String.singularize;